// extracted by mini-css-extract-plugin
export default {"preview":"yJLDw","landscape":"b3umA","portrait":"NWi8c","content":"a0QRP","image":"BqkuI"};